import uiGlobalModals from './global-modals/index.vue'
import uiBrokerModal from './broker-modal/index.vue'
import uiCreateTaskModal from './create-task-modal/index.vue'
import uiDealCreateHistoricalModal from './deal-create-historical-modal/index.vue'
import uiDealStageStatusModal from './status-modal/index.vue'
import uiDeleteDealModal from './delete-deal/index.vue'
import uiSelectUserModal from './select-users-modal/index.vue'
import uiEditTagModal from './tags/edit-tag-modal/index.vue'
import uiUserInfoModal from './user-info/index.vue'
import uiSelectReserveModal from './select-reserve-modal/index.vue'
import uiMoveToModal from './move-to/index.vue'
import uiSelectOriginModal from './select-origin-modal/index.vue'
import uiChooseUnitReserveModal from './choose-unit-reserve-modal/index.vue'
import uiCreateDealModal from './create-deal-modal/index.vue'
import uiMessageModal from './message-modal'
import uiFinancialAnalysisModal from './financial-analysis-modal'
import uiDuplicateDealModal from './duplicate-deal-modal'

export {
	uiGlobalModals,
	uiBrokerModal,
	uiCreateTaskModal,
	uiDealCreateHistoricalModal,
	uiDealStageStatusModal,
	uiDeleteDealModal,
	uiSelectUserModal,
	uiEditTagModal,
	uiUserInfoModal,
	uiSelectReserveModal,
	uiMoveToModal,
	uiSelectOriginModal,
	uiChooseUnitReserveModal,
	uiCreateDealModal,
	uiMessageModal,
	uiFinancialAnalysisModal,
	uiDuplicateDealModal
}
